import { render, staticRenderFns } from "./AddTax.vue?vue&type=template&id=5ab2f6de&scoped=true&"
import script from "./AddTax.vue?vue&type=script&lang=js&"
export * from "./AddTax.vue?vue&type=script&lang=js&"
import style0 from "./AddTax.vue?vue&type=style&index=0&id=5ab2f6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2f6de",
  null
  
)

export default component.exports